module.exports = __webpack_public_path__ + "media/prop/image_placeholder-5a4eff62.jpg";